/* eslint-disable */
import React from 'react';
import BackdropMUI from '@mui/material/Backdrop';
import { Loader } from './icons/Loader';

interface Props {
  open?: boolean;
}

export function Backdrop({ open = false }: Props) {
  return (
    <BackdropMUI
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <Loader height={70} width={70} />
    </BackdropMUI>
  );
}
